"use strict"; // An iterable WeakSet implementation inspired by the iterable WeakMap example code in the WeakRefs specification:
// https://github.com/tc39/proposal-weakrefs#iterable-weakmaps

var _regeneratorRuntime = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  function IterableWeakSet() {
    _classCallCheck(this, IterableWeakSet);

    this._refSet = new Set();
    this._refMap = new WeakMap();
    this._finalizationRegistry = new FinalizationRegistry(function (_ref) {
      var ref = _ref.ref,
          set = _ref.set;
      return set.delete(ref);
    });
  }

  _createClass(IterableWeakSet, [{
    key: "add",
    value: function add(value) {
      if (!this._refMap.has(value)) {
        var ref = new WeakRef(value);

        this._refMap.set(value, ref);

        this._refSet.add(ref);

        this._finalizationRegistry.register(value, {
          ref: ref,
          set: this._refSet
        }, ref);
      }

      return this;
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var ref = this._refMap.get(value);

      if (!ref) {
        return false;
      }

      this._refMap.delete(value);

      this._refSet.delete(ref);

      this._finalizationRegistry.unregister(ref);

      return true;
    }
  }, {
    key: "has",
    value: function has(value) {
      return this._refMap.has(value);
    }
  }, {
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ref, value;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;
              _iterator = this._refSet[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 15;
                break;
              }

              ref = _step.value;
              value = ref.deref();

              if (!(value === undefined)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("continue", 12);

            case 10:
              _context.next = 12;
              return value;

            case 12:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 21:
              _context.prev = 21;
              _context.prev = 22;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 24:
              _context.prev = 24;

              if (!_didIteratorError) {
                _context.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context.finish(24);

            case 28:
              return _context.finish(21);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[3, 17, 21, 29], [22,, 24, 28]]);
    })
  }]);

  return IterableWeakSet;
}();